// src/pages/Dashboard/ImageManager/ImageManagerPage.jsx
import React from "react";
import { env } from "../../../config/env";
import { getAuthToken } from "../../AdminAuth/components/authStore";
import ImageManager from "./ImageManager";


export default function ImageManagerPage() {
  const baseUrl = env?.CATALOG_BASE_URL || process.env.REACT_APP_CATALOG_BASE_URL || "";
  const token = getAuthToken?.() || "";

  return (
    <ImageManager
      baseUrl={baseUrl}
      authToken={token}
    />
  );
}
